import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */
// Custom hook that returns an array of role restrictions
export const useRoleRestrictionsArray = () => {
    const { t } = useTranslation(); // Destructure the translation function from the useTranslation hook
    const { singleRoleObj } = useSelector((state) => state?.EmployeeRolesSlice); // Access the singleRoleObj from the Redux store (EmployeeRolesSlice)

    return [
        {
            // Restriction for biocr validation
            res: t('biocr_validation'), // Translated label for biocr validation
            check: singleRoleObj?.roleRestriction?.biocrValidation, // The current state of the biocrValidation restriction
            name: 'biocrValidation', // Name of the restriction
            info: t('use_the_biocr_validatiaon_to_confirm_your_identity'), // Information about biocr validation
        },
        {
            // Restriction for event validation
            res: t('event_validation'), // Translated label for event validation
            check: singleRoleObj?.roleRestriction?.eventValidation, // The current state of the eventValidation restriction
            name: 'eventValidation', // Name of the restriction
            info: t('validate_the_event_who_created_in_this_role'), // Information about event validation
        },
        {
            // Restriction for extra data on employee
            res: t('extra_data_employee'), // Translated label for extra employee data
            check: singleRoleObj?.roleRestriction?.extraDataEmployee, // The current state of the extraDataEmployee restriction
            name: 'extraDataEmployee', // Name of the restriction
            info: t('add_extra_data_to_the_employee'), // Information about adding extra data to the employee
        },
        {
            // Restriction for keeping session active in the web app
            res: t('keep_session_active'), // Translated label for keeping the session active
            check: singleRoleObj?.roleRestriction?.keepSessionActiveWebApp, // The current state of the keepSessionActiveWebApp restriction
            name: 'keepSessionActiveWebApp', // Name of the restriction
            info: t('to_keep_the_session_al_the_time_active_in_the_web_app'), // Information about keeping the session always active
        },
        {
            // Restriction for sharing PDFs in the mobile app
            res: t('share_pdf_in_mobile_app'), // Translated label for sharing PDFs in the mobile app
            check: singleRoleObj?.roleRestriction?.sharePdfInMobileApp, // The current state of the sharePdfInMobileApp restriction
            name: 'sharePdfInMobileApp', // Name of the restriction
            info: t('to_use_the_6_degits_code_to_log_in_on_the_web_app'), // Information about sharing PDFs using a 6-digit code to log in
        },
        {
            // Restriction for using a token in the web app
            res: t('use_token_webapp'), // Translated label for using token in the web app
            check: singleRoleObj?.roleRestriction?.useTokenWebApp, // The current state of the useTokenWebApp restriction
            name: 'useTokenWebApp', // Name of the restriction
            info: t('to_use_the_6_degits_code_to_log_in_on_the_web_app'), // Information about using a 6-digit code to log in
        },
    ];
};
